import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

import './styles.scss'

type MiniPdpTechnicalContentProps = {
  productDocuments?: string | null
  technicalInformation?: string | null
}

const MiniPdpTechnicalContent = ({
  productDocuments,
  technicalInformation,
}: MiniPdpTechnicalContentProps) => {
  return (
    <>
      {productDocuments && (
        <article
          data-testid="miniPdpProductDocuments"
          className="mini-pdp-product-manual-and-docs productManualAndDocs"
        >
          <div
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(productDocuments),
            }}
          />
        </article>
      )}

      {technicalInformation && (
        <article
          data-testid="miniPdpTechnicalInformation"
          className="mini-pdp-product-technical-info product-technical-info"
          suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(technicalInformation),
          }}
        />
      )}
    </>
  )
}

export default memo(MiniPdpTechnicalContent)
